import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInfoDisclosure } from '../services';

// Thunk asíncrono para obtener los datos de team desde la API
export const fetchInfoDisclosureData = createAsyncThunk(
    'team/fetchInfoDisclosureData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchInfoDisclosure(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const infoDisclosureSlice = createSlice({
    name: 'team',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInfoDisclosureData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInfoDisclosureData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchInfoDisclosureData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default infoDisclosureSlice.reducer;
